const styles = () => ({
  title: { margin: '20px 0' },
  table: {
    minWidth: 650
  }
});

export default styles;
